import { http } from "./httpServices";
import {
  ANALYTICS,
  PROMOTION,
  REDEEM,
  SIGN_UP,
  SPIN,
  SPIN_WHEEL,
  USER,
  USER_RESEND_OTP,
  USER_VERIFY_PASSWORD,
  VERIFY,
  VERIFY_EMAIL,
} from "./constants";

export function postQRSignUp(data) {
  return http.post(`${USER}${SPIN}${SIGN_UP}`, data);
}

export function postQRVerifyOTP(data) {
  return http.post(`${USER}${SPIN}${USER_VERIFY_PASSWORD}`, data);
}

export function postQRResendOTP(data) {
  return http.post(`${USER}${SPIN}${USER_RESEND_OTP}`, data);
}

export function getSpinWheelData() {
  return http.get(`${PROMOTION}${SPIN_WHEEL}`);
}

export function postSpinWheelVerifyEmail(data) {
  return http.post(`${USER}${SPIN}${VERIFY_EMAIL}`, data);
}

export function postSpinWheelVerifyPhone(data) {
  return http.post(`${USER}${SPIN}${VERIFY}`, data);
}

export function getOutletDataByPromo(id) {
  return http.get(`${PROMOTION}${SPIN_WHEEL}/${id}`);
}

export function getSpunPromoData(spinId) {
  return http.post(`${USER}${SPIN}${REDEEM}`, { spinId });
}

export function addAnalytics(data) {
  return http.post(`${ANALYTICS}`, data);
}
